import { useCallback } from 'react';
import { collectCredentialErrors, pickChangedFieldErrors } from '../credentialV2Utils';

const validate = (cred) => {
  const errors = {};

  if (!cred?.data?.npi?.npi_number) {
    errors.npi_number = 'NPI number is required';
  }

  return errors;
};

const hasFieldChanged = (current, original) =>
  (current?.data?.npi?.npi_number ?? '') !== (original?.data?.npi?.npi_number ?? '');

export const useCredentialNpi = () => {
  const getErrors = useCallback(
    (current, original) =>
      pickChangedFieldErrors(validate(current), current, original, hasFieldChanged),
    [],
  );

  const validateAll = useCallback(
    (credentials) => collectCredentialErrors(credentials, validate),
    [],
  );

  return { getErrors, validateAll };
};
